import { X } from "lucide-react";

export const MediaPreview = ({ url, type, name, onClear, locked }) => (
  <figure className="rf-fade" data-testid="media-preview">
    <div className="bg-[var(--rf-soft)] border rf-line flex items-center justify-center">
      {type === "video" ? (
        <video src={url} controls playsInline className="max-h-[60vh] w-full object-contain" data-testid="media-preview-video" />
      ) : (
        <img src={url} alt={name} className="max-h-[60vh] w-full object-contain" data-testid="media-preview-image" />
      )}
    </div>
    <figcaption className="flex items-center gap-4 pt-3 border-b rf-line pb-3">
      <span className="rf-mono text-[10px] tracking-[0.2em] uppercase rf-red">{type === "video" ? "Video" : "Immagine"}</span>
      <span className="text-sm truncate" data-testid="media-preview-filename">{name}</span>
      {!locked && (
        <button onClick={onClear} className="ml-auto text-[var(--rf-grey)] hover:text-[var(--rf-red)]" data-testid="media-clear-button" aria-label="Rimuovi file">
          <X size={16} />
        </button>
      )}
    </figcaption>
  </figure>
);
